
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { I18nMixin } from '../../../mixins';
import { ISEOTitleOverrideI18n, ISEOTitleDefaultI18n } from '../types';

@Component
export default class WLTitle extends Mixins(I18nMixin) {
  @Prop()
  public overrideI18n!: ISEOTitleOverrideI18n;

  public defaultI18n!: ISEOTitleDefaultI18n;

  @Prop()
  private domain!: string;

  public created() {
    this.defaultI18n = {
      repair: this.$t('components_plugin.SEOZone.repair'),
    };
  }
}
